import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  method: yup.string().required(),
  answer: yup.string().required(),
  wpuId: yup.number().required(),
});

export function useSend2FaOtpMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.send2FaOtp(), req);
  }, options);
}
